// src/pages/ReservationForm.jsx
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import GeneralForm from "./forms/GeneralForm";
import CommuteForm from "./forms/CommuteForm";
import TourForm from "./forms/TourForm";
import SchoolForm from "./forms/SchoolForm";
import Header from "../Component/Header";

const typeToLabel = {
  general: "일반",
  school: "학단",
  commute: "통근",
  tour: "투어",
};

export default function ReservationForm() {
  const location = useLocation();
  const incomingType = location.state?.type;        // "general" | "school" | "commute" | "tour"
  const incomingPrefill = location.state?.prefill || null;

  const [type, setType] = useState("general");
  const [category, setCategory] = useState("일반");
  const [prefill, setPrefill] = useState(null);
  const [reservationMode, setReservationMode] = useState("예약");

  // 최초 진입 시: 배차처리에서 넘어온 타입/프리필 적용
  useEffect(() => {
    if (incomingType && typeToLabel[incomingType]) {
      setType(incomingType);
      setCategory(typeToLabel[incomingType]);
    }
    if (incomingPrefill) setPrefill(incomingPrefill);
  }, [incomingType, incomingPrefill]);

  const handlePick = (label) => {
    setCategory(label);
    setType(
      label === "통근"
        ? "commute"
        : label === "투어"
        ? "tour"
        : label === "학단"
        ? "school"
        : "general"
    );
    // 탭을 바꿀 때 프리필을 유지하려면 그대로 두고,
    // 탭 전환 시 프리필을 지우고 싶다면 아래 주석 해제:
    // setPrefill(null);
  };

  const renderForm = () => {
    const formProps = {
      prefill,
      targetTable: reservationMode === "가예약" ? "tentative_reservations" : "reservations",
      reservationMode,
    };
    switch (type) {
      case "commute":
        return <CommuteForm {...formProps} />;
      case "tour":
        return <TourForm {...formProps} />;
      case "school":
        return <SchoolForm {...formProps} />;
      default:
        return <GeneralForm {...formProps} />;
    }
  };

  return (
    <div className="space-y-1">
      <Header />
      <div className="flex px-4 py-1 items-center gap-4">
        <label className="font-semibold">구분</label>
        <div className="flex gap-2">
          {["일반", "학단", "통근", "투어"].map((label) => (
            <button
              key={label}
              type="button"
              onClick={() => handlePick(label)}
              className={
                category === label
                  ? "px-4 py-1 rounded-full border transition bg-blue-600 text-white"
                  : "px-4 py-1 rounded-full border transition bg-gray-100 text-gray-700 hover:bg-gray-200"
              }
            >
              {label}
            </button>
          ))}
        </div>
        <div className="ml-4 flex gap-2">
          {["예약", "가예약"].map((label) => (
            <button
              key={label}
              type="button"
              onClick={() => setReservationMode(label)}
              className={
                reservationMode === label
                  ? "px-4 py-1 rounded-full border transition bg-emerald-600 text-white"
                  : "px-4 py-1 rounded-full border transition bg-gray-100 text-gray-700 hover:bg-gray-200"
              }
            >
              {label}
            </button>
          ))}
        </div>
      </div>
      {renderForm()}
    </div>
  );
}
